import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const StateChildFormAcountManager = React.lazy(
  () =>
    import(
      "../screean/accountManager/childFormAccountManager/stateChildFormAccountManager"
    )
);
export function accountManagerCuentaCleringDetalle() {
  return (
    <Route
      path="/manager-cuenta-clearing-detalle"
      element={
        <ProtectedRoute>
          <ProtectedRoleAccountManager>
            <LazySuspense>
              <StateChildFormAcountManager />
            </LazySuspense>
          </ProtectedRoleAccountManager>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
